import React from 'react';

import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Skeleton from '@material-ui/lab/Skeleton';

import PlaceholdersTable from 'components/PlaceholdersTable';

function MenuMakerPublishPlaceholder() {
  return (
    <Box>
      <Box mb="3rem">
        <Box alignItems="center" component="header" display="flex" justifyContent="space-between" px={2}>
          <Skeleton height={80} width={100} />
          <Skeleton height={80} width={200} />
        </Box>
        <Table>
          <TableBody>
            <PlaceholdersTable placeholderCols={3} />
          </TableBody>
        </Table>
      </Box>

      <Box mb="3rem">
        <Box alignItems="center" component="header" display="flex" justifyContent="space-between" px={2}>
          <Skeleton height={80} width={100} />
          <Skeleton height={80} width={200} />
        </Box>
        <Table>
          <TableBody>
            <PlaceholdersTable placeholderCols={3} />
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
}

export default MenuMakerPublishPlaceholder;
